import { FC } from 'react';
import AllieHeaderDesktop, { AllieHeaderTitle as HeaderTitle } from './Header.desktop';
import AllieHeaderMobile from './Header.mobile';
import { isMobile } from '../../../common/utils';
import { HeaderProps } from './Header.types';
import { useScreen } from '../../../common/hooks';
import AllieHeaderMobileApp from './Header.mobileApp';

export const Header: FC<HeaderProps> = (props) => {
  const { isMobileHook } = useScreen();

  const HeaderPlatform = props.isAppMobileMenu
    ? AllieHeaderMobileApp
    : isMobileHook
      ? AllieHeaderMobile
      : AllieHeaderDesktop;

  return <HeaderPlatform {...props} />;
};

export const AllieHeaderTitle = HeaderTitle;
